////////////////////////////
// ad_spot
////////////////////////////
$(document).on('turbolinks:load', function() {
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

$(function() {
  return $('.ad-spot').on('click', function() {
    var checked;
    if ($(this).data('pref-code') === 0) {
      if (indexOf.call($(this).attr('class').split(' '), 'ad-spot-selected') >= 0) {
        checked = false;
        $('.ad-spot').removeClass('ad-spot-selected');
      } else {
        checked = true;
        $('.ad-spot').addClass('ad-spot-selected');
      }
      return $('.ad-spot').children('input:checkbox').prop('checked', checked);
    } else if ($(this).data('is-pref')) {
      if (indexOf.call($(this).attr('class').split(' '), 'ad-spot-selected') >= 0) {
        checked = false;
        $('.pref_code_' + $(this).data('pref-code')).removeClass('ad-spot-selected');
      } else {
        checked = true;
        $('.pref_code_' + $(this).data('pref-code')).addClass('ad-spot-selected');
      }
      return $('.pref_code_' + $(this).data('pref-code')).children('input:checkbox').prop('checked', checked);
    } else {
      if (indexOf.call($(this).attr('class').split(' '), 'ad-spot-selected') >= 0) {
        checked = false;
        $(this).removeClass('ad-spot-selected');
      } else {
        checked = true;
        $(this).addClass('ad-spot-selected');
      }
      return $(this).children('input:checkbox').prop('checked', checked);
    }
  });
});
});
//////////////////////////////////////
// developments.js
//////////////////////////////////////
$(function() {
  $('#search_graph_ms_lg_code').click(function() {
    return location.href = location.pathname + '?ms_lg_code=' + $("#ms_lg_code_id").val();
  });
  return $('#search_graph_action_id').click(function() {
    return location.href = location.pathname + '?action_id=' + $("#action_id").val();
  });
});
////////////////////////////////////// ​// iro_gadgets
//////////////////////////////////////
// # Place all the behaviors and hooks related to the matching controller here.
// # All this logic will automatically be available in application.js.
// # You can use CoffeeScript in this file: http://coffeescript.org/
$(function() {
  var toggle_kind;
  toggle_kind = function(kind) {
    var tr_code, tr_link;
    tr_code = $('#iro_gadget_code_tr');
    tr_link = $('#iro_gadget_link_tr');
    if (kind === '10') {
      tr_code.show().attr('disabled', false);
      return tr_link.hide().attr('disabled', true);
    } else {
      tr_code.hide().attr('disabled', true);
      return tr_link.show().attr('disabled', false);
    }
  };
  toggle_kind($('#iro_gadget_kind').val());
  return $('#iro_gadget_kind').on('change', function(event) {
    var kind;
    kind = $(event.currentTarget).val();
    return toggle_kind(kind);
  });
});
//////////////////////////////////////
// timeline_ds
//////////////////////////////////////
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://coffeescript.org/

$(function() {
  $("#ms_genre_id").hide();
  if ($("#timeline_ad_ad_kind_1").attr("checked")) {
    $("#ms_genre_id").slideToggle();
  }
  $('#timeline_ad_ad_kind_1').on('click', function(e) {
    var client_id, title;
    $("#ms_genre_id").show();
    client_id = $('#search_by_advertisement_client_id').val();
    title = $('#search_by_advertisement_title').val();
    return $.ajax({
      url: '/admin/timeline_ads/ms_lg_code_select',
      type: 'GET',
      data: {
        search_by: {
          pref: true
        }
      },
      dataType: 'html'
    }).done(function(data) {
      $('#ms_lg_code_select').html(data);
      return $('#timeline_ad_timeline_ad_areas_attributes__ms_lg_code_id').select2({
        width: 'resolve'
      });
    });
  });
  return $('#timeline_ad_ad_kind_2').on('click', function(e) {
    var client_id, title;
    $("#ms_genre_id").hide();
    client_id = $('#search_by_advertisement_client_id').val();
    title = $('#search_by_advertisement_title').val();
    return $.ajax({
      url: '/admin/timeline_ads/ms_lg_code_select',
      type: 'GET',
      data: {
        search_by: {
          city: true
        }
      },
      dataType: 'html'
    }).done(function(data) {
      $('#ms_lg_code_select').html(data);
      return $('#timeline_ad_timeline_ad_areas_attributes__ms_lg_code_id').select2({
        width: 'resolve'
      });
    });
  });
});
/////////////////////////////
// magazine.js
/////////////////////////////

$(document).on('turbolinks:load', function() {
  ready = function() {
  return $('#ms_local_government_code_select').on('click', function(e) {
    var pref, selected;
    selected = $('#ms_local_government_code option:selected');
    pref = selected.attr("class");
    if ($('#selected_ms_local_government_hidden :input[class=is_pref]').length > 0 || ($('#selected_ms_local_government_hidden :input').length > 0 && pref === "is_pref")) {
      alert("都道府県を選択する場合は一つのみ選択可能です");
      return;
    }
    if ($('#selected_ms_local_government_hidden :input[value=' + selected.val() + ']').html() !== "") {
      $("#selected_ms_local_government_codes").append('<div id=selected_ms_local_government_codes_' + selected.val() + ' class="ms_local_government_code_name">' + selected.text() + '<a class="ms_local_government_code_del_link" name="' + selected.val() + '">×</a></div>');
      return $("#selected_ms_local_government_hidden").append('<input type="hidden" class="' + pref + '" name="magazine[magazine_areas_attributes][][local_government_code]" value="' + selected.val() + '">');
    }
  });
  };

  $(document).ready(ready);
  $(document).on('page:change', ready);
})

$(document).on('turbolinks:load', function() {
  $(function() {
  $('#ms_local_government_code_button').on('click', function(e) {
    e.preventDefault();
    return $.ajax({
      url: '/admin/magazines/ms_local_government_code_select',
      type: 'GET',
      data: {
        name: $('#search').val()
      },
      dataType: 'html'
    }).done(function(data) {
      return $("#ms_local_government_code_box").html(data);
    });
  });
  return $(document).on('click', 'a.ms_local_government_code_del_link', function(e) {
    var code;
    code = $(this).attr('name');
    $('#selected_ms_local_government_codes_' + code + '').remove();
    return $('#selected_ms_local_government_hidden :input[value=' + code + ']').remove();
  });
  });
})
////////////////////////////
// rss_items
////////////////////////////
$(function() {
  $('.ms_genre_select').on('change', function(event) {
    target = $(event.currentTarget);
    target.attr('disabled', true);
    rss_item_id = target.attr('data_rss_item_id');
    selected_ms_genre_id = target.val();
    rss_item_genre_status = $("#rss-item-genre-status-#{rss_item_id}");
    rss_item_genre_status.text('更新中...').css('color', '#000000').fadeIn(0);

  $.ajax({
  url: "/admin/rss_items/" + rss_item_id + "/ajax_change_rss_item_genre",
  type: 'POST',
  dataType: 'text',
  data: {
    ms_genre_id: selected_ms_genre_id
  },
  error: function(err) {
    console.log(err);
  },
  success: function(data) {
    target.attr('disabled', false);
  }
});
rss_item_genre_status.css("color", '#3FFF21').text('ok!').fadeOut(2500)

  });
  $('#ms-genre-description-display').on('click', function(event) {
    $('#ms-genre-description').toggle();
  });
});

$('#ms-genre-description-display').on('click', function(event) {
  $('#ms-genre-description').toggle();
})


$(document).on('change', 'input#check_all', function(){
  if ($("input#check_all").prop("checked"))
    $('input.magazine_issue').prop("checked", true);
  else
    $('input.magazine_issue').prop("checked", false);
  end
});
